import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { apiSlice } from "../api/api";


export const setUpStore = (preLoadedState = {}) => {
	const store = configureStore({
		reducer: {
			[apiSlice.reducerPath]: apiSlice.reducer,
		},
        middleware: (gDM) => gDM().concat(apiSlice.middleware),
		// preLoadedState,
	});
	// Required for RTK Query's `refetchOnFocus`/`refetchOnReconnect` (opted into per-hook by the
	// plant-theme branding queries) to do anything — it wires the window focus/online listeners.
	setupListeners(store.dispatch);
	return store;
};

export const store = setUpStore();
